module.exports = __webpack_public_path__ + "img/interno.3b0c336c.svg";